<template>
  <div>
    <div class="pileDetail">
      <el-col :span="8" :lg="8" :xs="24">
        <el-image :src="image" />
      </el-col>
      <el-col :span="16" :lg="16" :xs="24">
        <div class="details">
          <div class="specifier">
            <h1>储能 50/100K 【光储一体机】</h1>
            <h3>产品特征 Product Features</h3>
            <ul>
              <li>采用双极拓扑，电压输入范围宽；</li>
              <li>可接入光伏电池板，支持光伏直充电，提高输出电流稳定性，充电过程更高效</li>
              <li>具备MPPT光伏最功率跟踪功能</li>
              <li>最大可接入两倍设备容量功率，最高可达200kw，提供无电地区产品配置的灵活性</li>
              <li>配合STS可实现并离网无缝切换</li>
            </ul>
          </div>
          <div class="application">
            <h3>应用领域 Application Area</h3>
            <span>中小型微电网、工商业楼宇等光储充一体化。</span>
          </div>
        </div>
      </el-col>
    </div>
    <el-divider></el-divider>
    <div class="table">
<!--      <el-table-->
<!--        :span-method="objectSpanMethod"-->
<!--        :data="tableData"-->
<!--        style="width: 95%">-->
<!--        <el-table-column-->
<!--          prop="type"-->
<!--          label="产品分类"-->
<!--          width="360px">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c50"-->
<!--          label="50K"-->
<!--          width="360px">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c100"-->
<!--          width="360px"-->
<!--          label="100K">-->
<!--        </el-table-column>-->
<!--      </el-table>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "Store50kw",
  data(){
    return{
      image:require('../../../assets/images/production/barrier/储能变流器50-250K.jpg'),
      tableData: [
        {
          type: '直流电压范围',
          c50:'250V~520V(额定400V)',
          c100:'250V~520V(额定400V)'
        },
        {
          type: '直流最大电流',
          c50:'150A',
          c100:'300A'
        },
        {
          type: 'PV电压范围',
          c50:'520~900V',
          c100:'520~900V'
        },
        {
          type: '最大PV电流',
          c50:'110A',
          c100:'220A'
        },
        {
          type: '最大PV功率',
          c50:'100KW',
          c100:'200KW'
        },
        {
          type: '额定电网电压',
          c50:'400±15%',
          c100:'400±15%'
        },
        {
          type: '电网频率范围',
          c50:'50Hz/60Hz±2.5Hz',
          c100:'50Hz/60Hz±2.5Hz'
        },
        {
          type: '隔离方式',
          c50:'工频隔离',
          c100:'工频隔离'
        },
        {
          type: '冷却方式',
          c50:'强制风冷',
          c100:'强制风冷'
        },
        {
          type: '防护等级',
          c50:'IP20',
          c100:'IP20'
        },
        {
          type: '尺寸',
          c50:'800*2160*800/800*2160*1000',
          c100:'800*2160*800/(户外版)'
        },
        {
          type: '上位机通信方式',
          c50:'ModBus TCP/IP',
          c100:'ModBus TCP/IP'
        },
        {
          type: '通信接口',
          c50:'网口、RS485、CAN',
          c100:'网口、RS485、CAN'
        }
      ]
    }
  },
  methods:{
    objectSpanMethod({row,column,rowIndex,columnIndex}){
      // console.log(row,column,rowIndex,columnIndex)
    }
  }
}
</script>

<style lang="less" scoped>
.pileDetail{
  margin: 30px 50px;
  overflow: hidden;
  .el-image{
    float: left;
    max-height: 523.8px;
    max-width: 379.8px;
    padding: 20px 20px;
  }
  .details{
    float: left;
    margin: 20px 0;
    .specifier{
      width: 85%;
      ul{
        width: 80%;
        li{
          list-style: none;
          &:before{
            content: '';
            display: inline-block;
            width: 10px;
            height: 10px;
            background-color: #2c6bb6;
            border-radius: 50%;
            margin-right: 5px;
          }
        }
      }
    }
    .application{
      float: left;
      width: 85%;
      span{
        padding-left: 5px;
      }
    }
  }
  h1{
    padding: 0 5px;
    color: #2c6cb6;
  }
  h3{
    padding: 0 5px;
    color: #2c6cb6;
  }
}
.table{
  margin: 30px 50px;
}
</style>

